module.exports = __webpack_public_path__ + "static/img/1.3f11f31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.jpg
// module id = Erzt
// module chunks = 94